import React, { useEffect, useState } from "react";
import { Menu, Popover } from "@arco-design/web-react";
import { useNavigate, useLocation } from "react-router-dom";
import { IconLeft, IconRight } from "@arco-design/web-react/icon";
import _ from "lodash";
import cs from "classnames";
import "./index.less";
import User from "@/stores/userStore";
import appStore from "@/stores/appStore";
import WorkSpaceIcon from "@/assets/images/work-space.png";
import UserIcon from "@/assets/images/user.png";
import DailiIcon from "@/assets/images/daili.png";
import KehuManageIcon from "@/assets/images/kehu.png";
import KehuProtectIcon from "@/assets/images/kehu-save.png";
import ZhanghaoIcon from "@/assets/images/zhanghao.png";
import CaiwuIcon from "@/assets/images/caiwuliushui.png";
import AnliIcon from "@/assets/images/anli.png";
import KefuIcon from "@/assets/images/kefu.png";
import CaseIcon from "@/assets/images/case.png";
import { observer } from "mobx-react";
import { getUserPermissions } from "@/components/business/RolePermission";

const { Item: MenuItem, SubMenu } = Menu;
const aid = +process.env.REACT_APP_AID || 0;

// 菜单数据结构，icon字段用占位字符串，实际可替换为真实icon

const Index = () => {
  const initMenu: any = [
    { id: "workspace", title: "工作台", icon: WorkSpaceIcon, hot: false, path: "/work-space", aids: [0, 1002] },
    {
      id: "account",
      title: "账号管理",
      icon: UserIcon,
      hot: false,
      path: "/account-management",
      hidden: !getUserPermissions("1"),
      aids: [0, 1002],
    },
    {
      id: "agent",
      title: "下级代理",
      hidden: !(User.userInfo.type == 1 && User.userInfo.role_id == 1),
      icon: DailiIcon,
      hot: false,
      path: "/subord-inateAgent",
      aids: [0, 1002],
    },
    {
      id: "customer",
      title: "客户管理",
      icon: KehuManageIcon,
      hot: false,
      path: "/customer-management",
      hidden: !getUserPermissions("2"),
      aids: [0, 1002],
    },
    {
      id: "case",
      title: "案例库",
      icon: CaseIcon,
      hot: false,
      path: "/case",
      hidden: !getUserPermissions("8"),
      children: [{ id: "geo-case", subTitle: "GEO案例", path: "/case-library/geo" }],
      aids: [0, 1002],
    },
    {
      id: "protect",
      title: "客户保护",
      icon: KehuProtectIcon,
      hot: false,
      path: "/customer-protection",
      hidden: !getUserPermissions("3"),
      aids: [0, 1002],
    },
    {
      id: "auth",
      title: "账号授权管理",
      icon: ZhanghaoIcon,
      hot: false,
      path: "/account-auth",
      hidden: !getUserPermissions("4"),
      aids: [1002],
    },
    {
      id: "finance",
      title: "财务流水",
      icon: CaiwuIcon,
      hot: false,
      path: "/financial-statement",
      hidden: !getUserPermissions("6"),
      aids: [0, 1002],
    },
    {
      id: "case-query",
      title: "案例查询",
      icon: AnliIcon,
      hot: false,
      path: "/case-query",
      hidden: !getUserPermissions("7"),
      aids: [1002],
    },
    {
      id: "service",
      title: "智能客服",
      icon: KefuIcon,
      hot: false,
      path: "/service",
      hidden: !getUserPermissions("8"),
      children: [
        { id: "service-message", subTitle: "私信管理", path: "/service/message", hidden: !getUserPermissions("8-1") },
        { id: "service-comment", subTitle: "评论管理", path: "/service/comment", hidden: !getUserPermissions("8-2") },
      ],
      aids: [1002],
    },
  ];
  const menuList = initMenu.filter((item) => item.aids.includes(aid));
  const [collapse, setCollapse] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [openKeys, setOpenKeys] = useState<string[]>([]);

  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
  useState<boolean>(false);
  // 根据路径获取对应的菜单项
  const getMenuItemByPath = (targetPath: string) => {
    for (const item of menuList) {
      if (item.path === targetPath) {
        return { parent: item };
      }
      if (item.children) {
        console.log(targetPath, "targetPath");
        const child = item.children.find((child) => targetPath.indexOf(child.path) > -1);
        if (child) return { parent: item, child };
      }
    }
    return undefined;
  };

  // 初始化选中的菜单项
  useEffect(() => {
    if (location.pathname !== "/") {
      const pathInfo = getMenuItemByPath(location.pathname);
      if (pathInfo) {
        setOpenKeys([pathInfo.parent.id]);
        // 如果child存在且hidden为true，则选中父级菜单，否则选中子菜单或父级
        if (pathInfo.child && pathInfo.child.hidden && pathInfo.child.meta?.activeMenu) {
          console.log(pathInfo.child.meta.activeMenu, "pathInfo.child.meta.activeMenu");

          setSelectedKeys([pathInfo.child.meta.activeMenu]);
        } else {
          setSelectedKeys([pathInfo.child ? pathInfo.child.id : pathInfo.parent.id]);
        }
      } else {
        setOpenKeys([]);
        setSelectedKeys([]);
      }
    }
  }, [location.pathname]);

  // 设置Logo宽度
  useEffect(() => {
    User.setLogoWidth(collapse ? 107 : 166);
  }, [collapse]);

  return (
    <div className="menu-root">
      {/* 折叠按钮 */}
      <div className="collapse-box" onClick={() => setCollapse(!collapse)}>
        {collapse ? <IconRight /> : <IconLeft />}
      </div>

      {/* 折叠状态下的菜单 */}
      {collapse ? (
        <div
          className="menu-container-collapse"
          style={{
            background: !appStore.isOdm ? "" : "linear-gradient(180deg, #dfeaff 0%, #F4F8FF 100%)",
          }}
        >
          {/* 折叠时仅显示icon */}

          {menuList
            .filter((item) => !item.hidden)
            .map((item) => {
              // 折叠时，一级菜单：有children显示子菜单弹窗，无children显示tooltip
              const hasChildren = Array.isArray(item?.children) && item?.children.length > 0;
              return (
                <Popover
                  key={item.id}
                  position="right"
                  trigger="hover"
                  color={"#000"}
                  content={
                    hasChildren ? (
                      <div style={{ minWidth: 120 }}>
                        {item.children.map((child) => (
                          <div
                            key={child.id}
                            style={{ padding: "8px 16px", cursor: "pointer", whiteSpace: "nowrap", color: "#ffffff" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate(child.path);
                            }}
                          >
                            {child.subTitle}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div style={{ padding: "8px 16px", color: "#fff" }}>{item.title}</div>
                    )
                  }
                >
                  <div
                    className={cs("menu-item-collapse", {
                      selected: selectedKeys.includes(item.id),
                    })}
                    style={{ textAlign: "center", padding: "16px 0", cursor: "pointer" }}
                    onClick={(e) => {
                      if (!hasChildren) {
                        navigate(item.path);
                      }
                    }}
                  >
                    <img style={{ width: 16, height: 16 }} src={item.icon} alt="" />
                  </div>
                </Popover>
              );
            })}
        </div>
      ) : (
        <div
          className="menu-container"
          style={{
            width: collapse ? 106 : 166,
            background: !appStore.isOdm ? "" : "linear-gradient(180deg, #dfeaff 0%, #F4F8FF 100%)",
          }}
        >
          {/* 展开时显示完整菜单结构 */}
          <Menu
            mode="vertical"
            selectedKeys={selectedKeys}
            openKeys={openKeys}
            onClickMenuItem={(key, e) => {
              let targetPath = "";
              for (const menu of menuList) {
                if (menu.id === key && menu.path) {
                  targetPath = menu.path;
                  break;
                }
                if (menu.children) {
                  const child = menu.children.find((child) => child.id === key);
                  if (child) {
                    targetPath = child.path;
                    break;
                  }
                }
              }
              if (targetPath) {
                navigate(targetPath);
              }
            }}
            onClickSubMenu={(key) => {
              setOpenKeys(openKeys[0] === key ? [] : [key]);
            }}
            style={{ width: "100%", background: "transparent" }}
          >
            {menuList
              .filter((item) => !item.hidden)
              .map((item) =>
                item.children ? (
                  <SubMenu
                    key={item.id}
                    title={
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <img style={{ width: 16, height: 16 }} src={item.icon} alt="" />
                        <span className={`iconfont icon-${item.icon[0]}`} style={{ marginRight: 8 }} />
                        {item.title}
                      </div>
                    }
                  >
                    {item.children
                      .filter((child) => !child.hidden)
                      .map((child) => (
                        <MenuItem key={child.id}>{child.subTitle}</MenuItem>
                      ))}
                  </SubMenu>
                ) : (
                  <MenuItem key={item.id}>
                    <img style={{ width: 16, height: 16 }} src={item.icon} alt="" />
                    <span className={`iconfont icon-${item.icon[0]}`} style={{ marginRight: 8 }} />
                    {item.title}
                  </MenuItem>
                )
              )}
          </Menu>
        </div>
      )}
    </div>
  );
};

export default observer(Index);
